import { Currency, InvoiceStatus, PurchaseOrderStatus } from '@shared/services/gql.service';

export enum MapPurchaseOrderStatus {
  PO_STATUS_CLOSED = 'Closed',
  PO_STATUS_OPEN = 'Open',
}

export interface POGridData {
  currency: Currency;
  invoice_summaries?: {
    accrual_period?: null | string;
    create_date: string;
    invoice_id: string;
    invoice_status: InvoiceStatus;
    total_amount?: null | number;
  }[];
  invoiced_against?: null | number;
  invoiced_against_variance: null | number;
  isPoEditableByPivot: boolean;
  last_invoice_date: string;
  linkedActivityTotal: null | number;
  organization_id: null | string;
  organization_name: null | string;
  paid_amount: null | number;
  paid_percentage: number;
  po_amount_variance: null | number;
  po_id: string;
  po_number?: string;
  po_remaining?: null | number;
  po_remaining_invoiced_amount: null | number;
  po_remaining_variance: null | number;
  po_report_amount: null | number;
  po_report_invoiced_amount: null | number;
  po_report_status?: null | PurchaseOrderStatus;
  po_status?: null | PurchaseOrderStatus;
  received_amount: null | number;
  received_percentage: number;
}
